export default "__VITE_ASSET__Daeq4Vk5__"